module.exports = __webpack_public_path__ + "statics/img/8.d5fc3e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo/8.jpg
// module id = 6p62
// module chunks = 1